import api from './api';
import moment from 'moment';
import { createApp, ref, defineComponent } from 'vue';
import { Button, Form, Input, Message, Menu, Layout, Drawer, Table, Divider, Descriptions } from 'ant-design-vue';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import router from './routes';

library.add(fas);
library.add(fab);

const app = createApp(App);
const components = [
  Button, Form, Input, Menu, Layout, Drawer, Table, Divider, Descriptions
];

for (const component of components) {
  app.use(component);
}

app.component('fa', FontAwesomeIcon);

router.beforeEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' :: Vertex - Panel';
  }
});

app.use(router);

const message = () => {
  return Message;
};

app.mixin({
  methods: {
    $goto: (a, b) => {
      b.push(a);
    },
    $api: api,
    $moment: moment,
    $message: message,
    $defineComponent: defineComponent,
    $ref: ref
  }
});

app.mount('#app');
